<template>
  <div>
    <el-radio-group v-model="values" v-if="inputType=='radio'" :disabled="editType=='examine'||editType=='info'||editType=='return'">
      <el-radio v-for="item in filterData" :key="item.dictId" :label="item.dictCode">{{item.dictName}}</el-radio>
    </el-radio-group>
    <el-checkbox-group v-model="values" v-else :disabled="editType=='examine'||editType=='info'||editType=='return'">
      <el-checkbox v-for="item in filterData" :key="item.dictId" :label="item.dictCode">{{item.dictName}}</el-checkbox>
    </el-checkbox-group>
  </div>
</template>

<script>
	import { getListDict } from '@/http/DictManagement.js'

  export default {
    props: ['dataOrigin', 'inputType', 'fieldName', 'editType', 'filterData'],
    data() {
      return {
        options: [],
        values: [],
        optionList: {},
        vdnId: ''
      }
    },
    watch: {
      
    },
    mounted() {
      this.vdnId = JSON.parse(LocalStorage.getItem("obj")).vdnId
      this.optionList = JSON.parse(LocalStorage.getItem('optionList'))||{}
    },
    created() {
    },
    methods: {
      //加载状态数据源
      fetchOptionListFn() {
        if (this.dataOrigin) {
          getListDict({
            dictTypeCode: this.dataOrigin,
            vdnId: this.vdnId
          }).then(res => {
            if(res && res.retCode == 1){
              this.options = res.data
            }
          })
        }
      },
    }
  }
</script>

<style scoped lang="scss">
.el-radio{
  line-height: 32px;
}
</style>



// WEBPACK FOOTER //
// RadioCheckBox.vue?45244c40